<template>
  <div class="container">
    <div class="header">
      <div class="left">
        <img src="../../assets/image/personCenter/person.png" alt="加载失败" />
        <div class="basicInfo">
          <div class="line">姓名：{{ xm }}</div>
          <div class="line">手机号：{{ sjhm }}</div>
          <div class="line">身份证号：{{ yxzjhm }}</div>
        </div>
      </div>
      <div class="right">
        <!-- <el-button type="primary" @click="addResume">新增个人简历</el-button> -->
        <el-button type="primary" @click="modifyInfo">修改个人信息</el-button>
      </div>
    </div>

    <moduleTitle title="我的报名信息"> </moduleTitle>
    <el-tabs v-model="regisType" :stretch="true">
      <el-tab-pane label="内部公开招聘" name="inside">
        <div v-for="(item, index) in regisInfoInside" :key="'inside' + index">
          <!-- <div class="resume">
            <div class="left">
              <div class="title">{{ item.zpqsbt + " - " + item.zpdw }}</div>
            </div>
            <div class="view" @click="showOrHide(item)">
              {{ detailMessage[item.show ? 1 : 0] }}
            </div>
            <div class="right">
              <span @click="modifyResume(item)">修改</span>
              <span @click="del(item)">删除</span>
            </div>
          </div> -->
          <regisInfoInside
            :formData="item"
            @deleted="queryBmxx"
          ></regisInfoInside>
          <!-- <resumeInfo
        :item="item"
        :disabled="item.disabled"
        v-show="item.show"
      ></resumeInfo> -->
        </div>
      </el-tab-pane>
      <el-tab-pane label="高校毕业生招聘（专业岗）" name="student">
        <div v-for="(item, index) in regisInfoStudent" :key="'student' + index">
          <regisInfoStudent
                  :formData="item"
                  @deleted="queryBmxx"
                  @updated="queryBmxx"
                  :zplb="'1'"
          ></regisInfoStudent>
        </div>
      </el-tab-pane>
      <el-tab-pane label="社会化招聘" name="outside">
        <div v-for="(item, index) in regisInfoOutside" :key="'outside' + index">
          <regisInfoOutside
            :formData="item"
            @deleted="queryBmxx"
            @updated="queryBmxx"
          ></regisInfoOutside>
        </div>
      </el-tab-pane>
      <el-tab-pane label="高技能人才招聘（操作岗）" name="technic">
        <div v-for="(item, index) in regisInfoTechnic" :key="'technic' + index">
          <regisInfoStudent
                  :formData="item"
                  @deleted="queryBmxx"
                  @updated="queryBmxx"
                  :zplb="'2'"
          ></regisInfoStudent>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import moduleTitle from "@/components/moduleTitle.vue";
import regisInfoInside from "./components/regisInfoInside.vue";
import regisInfoOutside from "./components/regisInfoOutside.vue";
import regisInfoStudent from "./components/regisInfoStudent.vue";
// import regisInfoTechnic from "./components/regisInfoTechnic.vue";
// import resumeInfo from "./components/resumeInfo.vue";
import request from "@/api/personCenter.js";
export default {
  components: {
    moduleTitle,
    regisInfoInside,
    regisInfoOutside,
    regisInfoStudent,
    // regisInfoTechnic
    // resumeInfo
  },
  data() {
    return {
      regisType: "inside", //报名类型
      regisInfoInside: [], //内部报名信息
      regisInfoOutside: [], //外部/社会化招聘报名信息
      regisInfoStudent: [], //高校招聘报名信息
      regisInfoTechnic: [], //高职技校生招聘报名信息
      xm: this.$store.state.userInfo.xm,
      sjhm: this.$store.state.userInfo.sjhm,
      yxzjhm: this.$store.state.userInfo.yxzjhm,
      // resumeList: [],
      detailMessage: ["查看报名信息", "收起报名信息"]
    };
  },
  mounted() {
    this.queryBmxx();
  },
  methods: {
    // addResume() {
    //   this.$router.push({
    //     name: "AddResume",
    //     params: {
    //       isTj: true
    //     }
    //   });
    // },
    modifyInfo() {
      this.$router.push({
        name: "ModifyInfo"
        // params: { ysjh: this.$store.state.userInfo.sjhm, }
      });
    },
    queryBmxx() {
      let param = {
        yhid: this.$store.state.userInfo.yhid
      };
      let that = this;
      request
        .queryBmxx(param)
        .then(function(data) {
          // that.resumeList = data.vds.map(item => {
          //   return Object.assign(item, {
          //     show: false,
          //     disabled: true
          //   });
          // });
          that.regisInfoInside = data.ds_nbzp_bmxx;
          that.regisInfoOutside = data.ds_shhzp_bmxx;
          that.regisInfoStudent = data.ds_gxzp_bmxx;
          that.regisInfoTechnic = data.ds_gzzp_bmxx;
          console.log("response");
          console.log("查询信息》》》》",data);
        })
        .catch(function(error) {
          console.log("error");
          console.log(error);
        });
    }
    // queryGrjl() {
    //   let param = {
    //     yhid: this.$store.state.userInfo.yhid
    //   };
    //   let that = this;
    //   request
    //     .queryGrjl(param)
    //     .then(function(data) {
    //       that.resumeList = data.vds.map(item => {
    //         return Object.assign(item, {
    //           show: false,
    //           disabled: true
    //         });
    //       });
    //       console.log("response");
    //       console.log(data);
    //     })
    //     .catch(function(error) {
    //       console.log("error");
    //       console.log(error);
    //     });
    // }
  }
};
</script>

<style lang="scss" scoped>
.container {
  width: 80%;
  margin: 40px auto;
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .left {
      display: flex;
      align-items: center;
      img {
        width: 103px;
        height: 103px;
      }
      .basicInfo {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        .line {
          margin-left: 20px;
          padding: 10px;
        }
      }
    }
    // .right {
    // }
  }
}
</style>
